import React, { useMemo, useState } from "react";
import "./TestimonialSlider.css";

const defaultTestimonials = [
  {
    quote: "Mailsnappy made our campaigns faster to build and easier to understand. The team finally has one clear place for templates, lists, and results.",
    author: "Jane Cooper",
    role: "Online Store Owner",
  },
  {
    quote: "The automation and segmentation tools helped us send more relevant messages without adding extra manual work for the marketing team.",
    author: "Matt Deegan",
    role: "British Podcast Awards",
  },
  {
    quote: "The pricing is transparent, the workflow is simple, and we can move from idea to email campaign without slowing down the business.",
    author: "Mike Rundle",
    role: "Designer",
  },
];

export default function TestimonialSlider({ title = "Loved by growing teams", items = defaultTestimonials }) {
  const testimonials = useMemo(() => (items.length ? items : defaultTestimonials), [items]);
  const [activeIndex, setActiveIndex] = useState(0);
  const active = testimonials[activeIndex];

  const move = (direction) => {
    setActiveIndex((current) => (current + direction + testimonials.length) % testimonials.length);
  };

  return (
    <section className="testimonial-slider-section">
      <div className="testimonial-slider-head">
        <span>Customer stories</span>
        <h2>{title}</h2>
      </div>

      <div className="testimonial-slider-card">
        <button type="button" className="testimonial-arrow" onClick={() => move(-1)} aria-label="Previous testimonial">
          &#8249;
        </button>

        <figure className="testimonial-slide">
          <blockquote>"{active.quote}"</blockquote>
          <figcaption>
            <strong>{active.author}</strong>
            <span>{active.role}</span>
          </figcaption>
        </figure>

        <button type="button" className="testimonial-arrow" onClick={() => move(1)} aria-label="Next testimonial">
          &#8250;
        </button>
      </div>

      <div className="testimonial-dots" aria-label="Choose testimonial">
        {testimonials.map((item, index) => (
          <button
            type="button"
            key={`${item.author}-${index}`}
            className={index === activeIndex ? "active" : ""}
            onClick={() => setActiveIndex(index)}
            aria-label={`Show testimonial ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
